import { Component, DoCheck, Input, ApplicationRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, AbstractControlDirective, AbstractControl } from '@angular/forms';
import { CpqInputBase } from '../cpq-input-base';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'cpq-input-error',
    templateUrl: './cpq-input-error.component.html',
    styleUrls: ['./cpq-input-error.component.scss', '../cpq-textarea/cpq-textarea.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqInputErrorComponent,
            multi: true
        }
    ],
    standalone: false
})
export class CpqInputErrorComponent extends CpqInputBase implements DoCheck {
  @Input('control') control: AbstractControlDirective | AbstractControl;
  @Input('dynamicWidth') dynamicWidth = false;
  @Input('hideLabel') hideLabel: boolean = false;
  @Input('id') id: string;
  @Input('errorHintPosition') errorHintPosition: 'left' | 'right' = 'right';
  public valid: boolean;

  constructor(
    public route: ActivatedRoute,
    public ref: ApplicationRef,
    public dialog: MatDialog
  ) {
    super(ref, dialog);
  }

  ngDoCheck() {
    this.doCheck();
  }

  private doCheck() {
    if (this.valid !== this.control.valid && !this.disabled) {
      this.valid = this.control.valid;
    }
  }
}
